import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";
import * as Cookies from 'js-cookie';


@Options({
    template: false,
    ui: {}
})

export default class BlogListReadMore extends Marionette.View<Backbone.Model>{
    config?: object;
    element?: any;

    constructor(options?: object, config?: object) {
        super(options);
        this.config = config || {};

        this.element = this.$el[0];
    }

    onRender() {
        let moreButton = this.element.querySelector('.blog-more');

        if (!moreButton) {
            return;
        }

        moreButton.addEventListener('click', event => {
            let hiddenPosts = this.element.querySelectorAll('.blog-post-card--hidden');

            hiddenPosts.forEach(post => {
                post.classList.remove('blog-post-card--hidden');
            });

            moreButton.remove();
        }, false);
    }
}




// WEBPACK FOOTER //
// ./@modules/views/blog-list-read-more.ts